export default function (receiver, supplier) {

    const propsNames = Object.getOwnPropertyNames(supplier);
    propsNames.forEach((property) => {
        if (supplier.hasOwnProperty(property) && property !== 'constructor') {
            Object.defineProperty(receiver, property, Object.getOwnPropertyDescriptor(supplier, property));
        }
    });

    return receiver;
}



// WEBPACK FOOTER //
// ./js/modules/privates/utils/mixin.es6